(function($){
  
  $('.vertical-carousel-block').each(function(index, item) {
    const carousel = item.querySelector('.vertical-carousel');

    $(carousel).slick({
      mobileFirst : true,
      dots        : false,
      infinite    : true,
      prevArrow   : item.querySelector('.slick-prev'),
      nextArrow   : item.querySelector('.slick-next'), 

      responsive  : [
        {
          breakpoint : 992,
          settings   : {
            centerMode:  true,
            centerPadding: '120px',
            vertical    : true,
            verticalSwiping: true
          }
        }
      ] 
    })
  });

})(jQuery);